import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationServiceService } from "../authentication-service/authentication-service.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationServiceService,
    private router: Router
  ) {}
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const tokenData = await this.authService.getCurrentUser();
    if (!tokenData) {
      this.router.navigate(["/login"]);
      return false;
    }
    return true;
  }
}